import React from 'react';
import { SharedIcon } from '@common_components/icons/shared.icon';
import { PieChartIcon } from '@common_components/icons/pieChart.icon';

export const CompletionIndicator: React.FC<{ percentage?: number, displayPourcent?: boolean }> = ( { percentage, displayPourcent = true } ) => {
  if ( typeof percentage !== 'number' ) {
    return null;
  }
  return (
    <div className='flex items-center gap-2'>
      {
        displayPourcent && (
          <div className='relative flex-center'>
            {percentage === 100 ? (
              <PieChartIcon size={5} className='bg-amber-300 text-amber-900 p-0.5 rounded-md' />
            ) : (
              <svg width={24} height={24} className="block">
                <circle
                  cx={12}
                  cy={12}
                  r={10}
                  stroke="#e5e7eb"
                  strokeWidth={3}
                  fill="none"
                />
                {percentage > 0 && percentage < 100 && (
                  <circle
                    cx={12}
                    cy={12}
                    r={11}
                    stroke={'#22c55e'}
                    strokeWidth={2}
                    fill="none"
                    strokeDasharray={2 * Math.PI * 11}
                    strokeDashoffset={
                      2 * Math.PI * 11 * ( 1 - percentage / 100 )
                    }
                    strokeLinecap="round"
                    style={{ transition: 'stroke-dashoffset 0.3s' }}
                  />
                )}
              </svg>
            )}
            {percentage > 0 && percentage < 100 && (
              <span className="absolute text-[9px] font-bold">
                {Math.round( percentage )}
                <span className="text-[6px] font-bold align-super">%</span>
              </span>
            )}
          </div>
        )
      }
      <SharedIcon size={5} className="bg-orange-300 text-orange-700 p-[3px] rounded-md" />
    </div>
  );
};

export default CompletionIndicator;
